module.exports = __webpack_public_path__ + "static/logos-tiles-amgen-aa16d3470a1f0b766ac60616cfa1d37d.svg";